/* eslint-disable indent */
'use strict';

import angular from 'angular';
import raven from 'raven';
import * as Config from 'config';
import * as moment from 'moment';
import DoAssignationController from './do-assignation.controller';
import DoAssignationTpl from './do-assignation.html';
import ChangeStatusController from './change-status.controller';
import ChangeStatusTpl from './change-status.html';
import SimpleMessages from 'app/controllers/simple-messages';
import AssignationController from '../assignation/assignation.controller';
import ngAsync from 'app/async/async.function.decorator';

export default class AssignationsController {
  static $inject = [
    'AssignationsService',
    'WorkersService',
    'RegistriesService',
    'AgenciesService',
    'OperationsService',
    '$mdDialog',
    '$mdToast',
    '$scope',
    '$q',
    '$window',
    'LoopBackAuth'
  ];
  AssignationsService;
  WorkersService;
  RegistriesService;
  AgenciesService;
  OperationsService;
  query = {};
  assignations: any[] = [];
  assignationsCount: number;
  $scope: any;
  $mdDialog: any;
  $mdToast: any;
  $window: any;
  LoopBackAuth: any;

  worker: any;
  date: any;
  registry: any;
  status: string = 'all';

  selectedAllAssignations: boolean;
  selectedAnyAssignation: boolean;

  searchAgencyText: string = '';
  agencies: any[] = [];

  onPagination = (): Promise<void> => this.getAssignations();

  constructor(
    AssignationsService,
    WorkersService,
    RegistriesService,
    AgenciesService,
    OperationsService,
    $mdDialog,
    $mdToast,
    $scope,
    $q,
    $window,
    LoopBackAuth
  ) {
    Object.assign(this, {
      AssignationsService,
      WorkersService,
      RegistriesService,
      AgenciesService,
      OperationsService,
      $mdDialog,
      $mdToast,
      $scope,
      $q,
      $window,
      LoopBackAuth
    });

    this.query = {
      limit: 50,
      page: 1,
      where: {},
      order: 'createdAt DESC',
      include: [
        {
          relation: 'operation',
          scope: {
            include: ['holder', 'vehicle', 'operationType', 'agency']
          }
        },
        'worker',
        'registry'
      ]
    };
    //this.assignations = $scope.$parent.$resolve.assignations;
    this.getAssignations();

    $scope.selectedAssignationIds = {};
    $scope.$watch(
      'selectedAssignationIds',
      (newlySelected: any) => {
        if (!newlySelected) {
          return;
        }
        this.selectedAnyAssignation =
          Object.keys(newlySelected).filter(a => newlySelected[a]).length > 0
            ? true
            : false;
      },
      true
    );
  }

  @ngAsync()
  async getAssignations(): Promise<void> {
    const opts = JSON.parse(JSON.stringify(this.query));

    let wheres = [];
    if (this.worker) {
      wheres.push({
        workerId: this.worker.id
      });
      opts.order = 'date ASC, registryId ASC';
    }
    if (this.registry) {
      wheres.push({
        registryId: this.registry.id
      });
    }
    if (this.date) {
      wheres.push({
        or: [
          {
            date: {
              gte: moment(this.date).startOf('day')
            }
          },
          {
            statusDate: {
              gte: moment(this.date).startOf('day')
            }
          }
        ]
      });
      wheres.push({
        or: [
          {
            date: {
              lte: moment(this.date).startOf('day')
            }
          },
          {
            statusDate: {
              lte: moment(this.date).startOf('day')
            }
          }
        ]
      });
    }
    if (this.status != 'all') {
      wheres.push({
        status: this.status
      });
    }

    if (this.agencies.length > 0) {
      wheres.push({
        agencyId: {
          inq: this.agencies.map(a => a.id)
        }
      });
    }

    opts.where.and = wheres;
    this.assignations = await this.AssignationsService.getModels(opts);
    if (this.date) {
      this.assignations.sort((a, b) => a.registryId - b.registryId);
    }
    this.assignationsCount = (
      await this.AssignationsService.getCount(opts)
    ).count;

    this.$scope.selectedAssignationIds = {};
    this.selectedAllAssignations = false;
  }

  queryWorkerSearch(text) {
    return this.WorkersService.find({
      filter: {
        where: {
          name: {
            ilike: `%${text}%`
          }
        }
      }
    });
  }

  queryRegistrySearch(text) {
    return this.RegistriesService.find({
      filter: {
        where: {
          name: {
            ilike: `%${text}%`
          }
        }
      }
    });
  }

  onToggleAssignation(assignation: any) {
    this.selectedAllAssignations = false;
  }

  onToggleAll() {
    if (this.selectedAllAssignations) {
      this.$scope.selectedAssignationIds = {
        ...this.assignations.reduce((accum: any, a: any) => {
          accum[a.id] = true;
          return accum;
        }, {})
      };
    } else {
      this.$scope.selectedAssignationIds = {};
    }
  }

  @ngAsync()
  async doAssignation(ev) {
    try {
      const selectedAssignationIds = Object.keys(
        this.$scope.selectedAssignationIds
      )
        .filter(a => this.$scope.selectedAssignationIds[a])
        .map(id => parseInt(id, 10));
      const uniqueDates = selectedAssignationIds
        .map(id => this.assignations.find(a => a.id == id).date)
        .filter((a, index, self) => self.indexOf(a) == index);
      const uniqueWorker = selectedAssignationIds
        .map(id => this.assignations.find(a => a.id == id).workerId)
        .filter((a, index, self) => self.indexOf(a) == index);
      const suggestedDate =
        uniqueDates.length == 1 ? moment(uniqueDates[0]).toDate() : null;
      const suggestedWorker =
        uniqueWorker.length == 1
          ? this.assignations.find(a => a.id == selectedAssignationIds[0])
              .worker
          : null;
      const data = await this.$mdDialog.show({
        controller: DoAssignationController,
        template: DoAssignationTpl,
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        locals: {
          assignationsCount: selectedAssignationIds.length,
          allAssignationsCount: this.assignationsCount,
          suggestedDate,
          suggestedWorker
        }
      });
      if (!data || !data.worker || !data.date) {
        return;
      }
      const { worker } = data;
      const date = moment(data.date).startOf('day');
      await this.AssignationsService.updateByIds(selectedAssignationIds, {
        workerId: worker.id,
        status: 'draft',
        statusDate: null,
        statusComments: '',
        date
      });
      this.worker = worker;
      this.date = date;
      this.status = 'draft';
      this.simpleSuccess();
      this.getAssignations();
    } catch (err) {
      if (err) {
        raven.captureException(new Error(err));
        // eslint-disable-next-line no-console
        console.error(err);
        this.simpleError();
      }
    }
  }

  @ngAsync()
  async changeStatus(ev, status) {
    try {
      const selectedAssignationIds = Object.keys(
        this.$scope.selectedAssignationIds
      )
        .filter(a => this.$scope.selectedAssignationIds[a])
        .map(id => parseInt(id, 10));
      const uniqueDates = selectedAssignationIds
        .map(id => this.assignations.find(a => a.id == id).date)
        .filter((a, index, self) => self.indexOf(a) == index);
      const suggestedDate =
        uniqueDates.length == 1 ? moment(uniqueDates[0]).toDate() : null;
      const data = await this.$mdDialog.show({
        controller: ChangeStatusController,
        template: ChangeStatusTpl,
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        locals: {
          assignationsCount: selectedAssignationIds.length,
          allAssignationsCount: this.assignationsCount,
          suggestedDate,
          status
        }
      });
      if (!data || !data.statusDate) {
        return;
      }
      const { statusComments } = data;
      const statusDate = moment(data.statusDate).startOf('day');
      const opts = {
        statusDate,
        statusComments,
        status
      };
      await this.AssignationsService.updateByIds(selectedAssignationIds, opts);
      if (status !== 'reassign') { // reassign is not an actual status
        this.status = status;
      }
      this.date = statusDate;
      this.simpleSuccess();
      this.getAssignations();
    } catch (err) {
      if (err) {
        raven.captureException(new Error(err));
        // eslint-disable-next-line no-console
        console.error(err);
        this.simpleError();
      }
    }
  }

  simpleError() {
    this.$mdToast.show(
      this.$mdToast.simple({
        toastClass: 'error',
        hideDelay: 2500,
        textContent: 'Ocurrio un error'
      })
    );
  }

  simpleSuccess(msg = `Operación completada con éxito`, hideDelay = 2500) {
    if (!this.$mdToast) {
      return;
    }
    this.$mdToast.show(
      this.$mdToast.simple({
        toastClass: 'success',
        hideDelay,
        textContent: msg
      })
    );
  }
1
  pdf() {
    const date = moment(this.date).format('YYYY-MM-DD');
    const url = `${Config.publicUrl}/api/Assignations/pdf?\
workerId=${this.worker.id}&date=${date}&\
access_token=${this.LoopBackAuth.accessTokenId}`;
    this.$window.open(url);
  }

  addAgency() {
    this.getAssignations();
  }

  removeAgency() {
    this.getAssignations();
  }

  queryAgencySearch(text: string) {
    return this.AgenciesService.find({
      filter: {
        where: {
          name: {
            regexp: `^.*${text}.*$/i`
          }
        }
      }
    });
  }
}
